import { render } from "./AddProfile.vue?vue&type=template&id=ef3d54aa&scoped=true"
import script from "./AddProfile.vue?vue&type=script&lang=js"
export * from "./AddProfile.vue?vue&type=script&lang=js"

import "./AddProfile.vue?vue&type=style&index=0&id=ef3d54aa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3d54aa"]])

export default __exports__